/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Signup_ErrorInputs */

const en_newsletter_signup_error = /** @type {(inputs: Newsletter_Signup_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Try again in a moment.`)
};

/**
* | output |
* | --- |
* | "Something went wrong. Try again in a moment." |
*
* @param {Newsletter_Signup_ErrorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_signup_error = /** @type {((inputs?: Newsletter_Signup_ErrorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Signup_ErrorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_signup_error(inputs)
});